import { render, staticRenderFns } from "./Smart.vue?vue&type=template&id=5165c068&lang=pug&"
import script from "./Smart.vue?vue&type=script&lang=js&"
export * from "./Smart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports